// Homepage animation

export const bannerFrom = {
  opacity: 0,
  x: "-100%",
};
export const bannerTo = {
  opacity: 1,
  x: "0%",
};
export const bannerTransition = {
  type: "spring",
  stiffness: 90,
  duration: 0.5,
};
export const bannerTransitionWithDelay = {
  type: "spring",
  stiffness: 180,
  delay: 1,
  duration: 1,
};
export const titleFrom = {
  opacity: 0,
  y: -100,
};
export const titleTo = {
  opacity: 1,
  y: 0,
};
export const titleTransition = {
  type: "spring",
  stiffness: 500,
  duration: 1.5,
};
export const serviceOneFrom = {
  opacity: 0,
  y: "50%",
};
export const serviceOneTo = {
  opacity: 1,
  y: 0,
};
export const serviceOneTransition = {
  delay: 0.5,
  duration: 0.6,
};
export const serviceTwoFrom = {
  opacity: 0,
  y: "50%",
};
export const serviceTwoTo = {
  opacity: 1,
  y: 0,
};
export const serviceTwoTransition = {
  delay: 0.5,
  duration: 1.2,
};
export const serviceThreeFrom = {
  opacity: 0,
  y: "50%",
};
export const serviceThreeTo = {
  opacity: 1,
  y: 0,
};
export const serviceTreeTransition = {
  delay: 0.5,
  duration: 1.7,
};
export const contactBodyFrom = {
  opacity: 0,
  x: "-100%",
};
export const contactBodyTo = {
  opacity: 1,
  x: 0,
};
export const contactBodyTransition = {
  delay: 1,
  type: "spring",
  stiffness: 180,
  duration: 1,
};
export const contactFormFrom = {
  opacity: 0,
};
export const contactFormTo = {
  opacity: 1,
};
export const contactFormTransition = {
  delay: 1,
  duration: 1,
};

// about page animation

export const topTitleFrom = {
  opacity: 0,
  y: -100,
};
export const topTitleTo = {
  opacity: 1,
  y: 0,
};
export const topTitleTransition = {
  duration: 0.5,
};
export const animationBallFrom1 = {
  scale: 0,
};
export const animationBallTo1 = {
  scale: 1,
};
export const animationBallFrom2 = {
  scale: 2,
};
export const animationBallTo2 = {
  scale: 1,
};
export const animatedImgFrom = {
  y: 6,
};
export const animatedImgTo = {
  y: -6,
};
export const animatedImgTransition = {
  duration: 4,
  yoyo: Infinity,
};
export const animationBallTransition = {
  duration: 0.5,
  yoyo: Infinity,
};

// router animation

export const routerAnimationFrom = {
  opacity: 0,
};
export const routerAnimationTo = {
  opacity: 1,
};
export const routerAnimationExit = {
  opacity: 0,
};
export const routerAnimationTransition = {
  duration: 0.5,
  ease: "easeInOut",
};
